import React from "react";
import Container from "@mui/material/Container";
import './About.css';
import AboutConferenceArea from "./AboutConferenceComponent";
import AboutStaffComponent from "./AboutStaffComponent";
import { useGlobal } from "../../utils/GlobalContext";
import { useNavigate } from "react-router-dom";

export default function About() {
    const { state, dispatch } = useGlobal();
    const navigate = useNavigate();
    if (state.UserProfile.IsExistingUser === false && state.UserProfile.Id!=="") {
      navigate("/account");
  }
    return (
        <div className="container">
            <Container maxWidth="xl">
                <AboutConferenceArea/>
                { state.SelectedEvent.Staff.length===0?
                    <></>:
                    <AboutStaffComponent/>
                }
            </Container>
        </div>
    )
}